// extracted by css-extract-rspack-plugin
export default {"cls1":"mentions_milestone_ping-cls1_Wn7","cls2":"mentions_milestone_ping-cls2_Hyt mentions_milestone_ping-cls1_Wn7"};